export default {
  en: [
    {
      name: 'Troubleshoot system problems',
      icon: 'mdi-clipboard-text-outline',
      blurb: 'Sometimes finding a problem is not as easy as it sounds!'
    },
    {
      name: 'Application Architecture Development',
      icon: 'mdi-pencil-outline',
      blurb: 'I use design patterns, but do not pop them wherever you can!'
    },
    {
      name: 'Application creation',
      icon: 'mdi-settings-outline',
      blurb: 'Clean and clear code, the use of best practices and frameworks.'
    },
    {
      name: 'Support',
      icon: 'mdi-account',
      blurb: 'I can make changes and adjustments from time to time, preferably in projects that I created myself.'
    }
  ],
  ru: [
    {
      name: 'Поиск и устранение "Неисправностей" в системе',
      icon: 'mdi-clipboard-text-outline',
      blurb: 'Иногда найти проблему, не так просто как кажется!'
    },
    {
      name: 'Разработка архитектуры',
      icon: 'mdi-pencil-outline',
      blurb: 'Я использую паттерны проектирования, но не сую их везде где можно!'
    },
    {
      name: 'Создание приложений',
      icon: 'mdi-settings-outline',
      blurb: 'Чистый и понятный код, использование лучших практик и фреймворков.'
    },
    {
      name: 'Поддержка приложений',
      icon: 'mdi-account',
      blurb: 'Я могу время от времени вносить изменения и коррективы, желательно в проекты которые создавал сам.'
    }
  ],
  uk: [
    {
      name: 'Пошук та усунення "Несправностей" в системі',
      icon: 'mdi-clipboard-text-outline',
      blurb: 'Іноді знайти проблему, не так просто як здається!'
    },
    {
      name: 'Розробка архітектури додатків',
      icon: 'mdi-pencil-outline',
      blurb: 'Я використовую патерни проектування, але не суну їх всюди де можна!'
    },
    {
      name: 'Безпосередньо створення додатків',
      icon: 'mdi-settings-outline',
      blurb: 'Чистий і зрозумілий код, використання кращих практик та фреймворків.'
    },
    {
      name: 'Підтримка проектів',
      icon: 'mdi-account',
      blurb: 'Я можу час від часу вносити зміни і корективи, бажано в проекти які створював сам.'
    }
  ]
}
